import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getUserPermissions } from "./API/core.service";
import { INTERVAL } from "../constants/clientTime";
import { FLAGS } from "@coworker/enums/featureFlags";
import { useUID } from "../core/auth/useLoggedInUser";

async function fetchUserPermissions(uid: string) {
  return await getUserPermissions(uid);
}

export function useUserPermissionsQuery() {
  const uid = useUID();
  const result = useQuery({
    queryKey: ["userPermissions", uid],
    queryFn: async () => await fetchUserPermissions(uid),
    staleTime: INTERVAL.WEEK, // Stale for a week
    refetchOnWindowFocus: false,
  });

  return result;
}
// Previous implementation was redundant since setOfFlags would be a new object on each render
// useMemo ensures setOfFlags only changes when data changes
export function useFlagsState() {
  const { data: userPermissions } = useUserPermissionsQuery();
  const setOfFlags = React.useMemo(
    () => new Set(userPermissions),
    [userPermissions]
  );
  return { setOfFlags };
}

function useFlag(flag: string) {
  const { setOfFlags } = useFlagsState();
  const hasFlag = React.useMemo(() => {
    return setOfFlags.has(flag);
  }, [setOfFlags, flag]);
  return hasFlag;
}

export default useFlag;
export { FLAGS };
